import dayjs from "dayjs";

export const sleep = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

// 전화번호 포맷 함수
export const formatPhoneNumber = (value: string): string => {
  const numbersOnly = value.replace(/\D/g, "");

  // 11자리를 초과하면 11자리까지만 자름
  const limitedNumbers = numbersOnly.slice(0, 11);

  if (limitedNumbers.length <= 3) return limitedNumbers;
  if (limitedNumbers.length <= 7)
    return `${limitedNumbers.slice(0, 3)}-${limitedNumbers.slice(3)}`;
  if (limitedNumbers.length <= 11)
    return `${limitedNumbers.slice(0, 3)}-${limitedNumbers.slice(
      3,
      7,
    )}-${limitedNumbers.slice(7, 11)}`;

  return limitedNumbers; // 이 경우는 실제로 발생하지 않음 (위에서 11자리로 제한했으므로)
};

/**
 * 두 날짜(date1, date2)를 받아 날짜(자정 기준)로 계산하고, 당일도 포함하여 일수 차이를 반환합니다.
 * @param date1 시작일 (string | Date)
 * @param date2 종료일 (string | Date)
 * @returns number (date2 - date1 + 1)
 */
export function dateDiffIncludeToday(
  date1: string | Date,
  date2: string | Date,
): number {
  return (
    dayjs(date2).startOf("day").diff(dayjs(date1).startOf("day"), "day") + 1
  );
}
